import { hooks } from "./hookactions"
export let SVLNewServiceStep3 = { hooks }
